import { CommonRepairerService } from '@savgroup-front-common/core/api/Repairer';

import { deleteGeographicZoneCommand } from '@/api/Repairer/deleteGeographicZoneCommand';
import deleteQuoteMarginConfigurationCommand from '@/api/Repairer/deleteQuoteMarginConfigurationCommand';
import deleteRepairerQuoteMarginConfigurationCommand from '@/api/Repairer/deleteRepairerQuoteMarginConfigurationCommand';
import deleteTechnicianCommand from '@/api/Repairer/deleteTechnicianCommand';
import { canCreateQuotationOnFileIdQuery } from '@/api/Repairer/files/canCreateQuotationOnFileIdQuery';
import getAvailableTimeSlotsQuery from '@/api/Repairer/getAvailableTimeSlotsQuery';
import getCurrentQuotation from '@/api/Repairer/getCurrentQuotation/getCurrentQuotation';
import { getGeographicZonesQuery } from '@/api/Repairer/getGeographicZonesQuery';
import getInterventionReportQuery from '@/api/Repairer/getInterventionReportQuery';
import getQuoteMarginConfigurationQuery from '@/api/Repairer/getQuoteMarginConfigurationQuery';
import getRepairersBySellerIdQuery from '@/api/Repairer/getRepairersBySellerIdQuery';
import getTechnicalInterventionsByDatesQuery from '@/api/Repairer/getTechnicalInterventionsByDatesQuery';
import { getTechnicianByIdQuery } from '@/api/Repairer/getTechnicianByIdQuery';
import getTechniciansBySellerIdQuery from '@/api/Repairer/getTechniciansBySellerIdQuery';
import getWorkTypesBySellerQuery from '@/api/Repairer/getWorkTypesBySellerQuery/getWorkTypesBySellerQuery';
import getFilterFullIndexesQuery from '@/api/Repairer/interventionReport/getFilterFullIndexesQuery';
import { searchInterventionReportsCommand } from '@/api/Repairer/interventionReport/searchInterventionReportsCommand';
import setInterventionReportLineStatusCommand from '@/api/Repairer/interventionReport/setInterventionReportLineStatusCommand';
import {
  deleteSelfOnboardingServiceCommand,
  getSelfOnboardingServiceDetailQuery,
  getSelfOnboardingServicesQuery,
  upsertSelfOnboardingServiceCommand,
} from '@/api/Repairer/selfonboarding';
import setNewLoan from '@/api/Repairer/setNewLoan';
import setQuotation from '@/api/Repairer/setQuotation/setQuotation';
import setQuoteMarginConfigurationCommand from '@/api/Repairer/setQuoteMarginConfigurationCommand';
import setRepairerQuoteMarginConfigurationCommand from '@/api/Repairer/setRepairerQuoteMarginConfigurationCommand';
import { updateGeographicZoneCommand } from '@/api/Repairer/updateGeographicZoneCommand';
import updateLoanCommand from '@/api/Repairer/updateLoanCommand';
import updateQuotation from '@/api/Repairer/updateQuotation/updateQuotation';
import updateTechnicalInterventionCommand from '@/api/Repairer/updateTechnicalInterventionCommand';
import upsertTechnicianCommand from '@/api/Repairer/upsertTechnicianCommand';
import upsertWorkTypeCommand from '@/api/Repairer/upsertWorkTypeCommand';

import { createGeographicZoneCommand } from './createGeographicZoneCommand';
import createPlanningCommentCommand from './createPlanningCommentCommand';
import createTechnicalInterventionCommand from './createTechnicalInterventionCommand';

export const RepairerService = {
  getIrisCode: CommonRepairerService.getIrisCode,
  setInterventionReport: CommonRepairerService.setInterventionReport,
  setInterventionReportExtended:
    CommonRepairerService.setInterventionReportExtended,

  getInterventionReportQuery,
  getInterventionReport: CommonRepairerService.getInterventionReport,
  getLastCreatedQuotationByFileIdQuery:
    CommonRepairerService.getLastCreatedQuotationByFileIdQuery,
  updateLoanCommand,
  setNewLoan,
  getAvailableServicesForInterventionReportByFileId:
    CommonRepairerService.getAvailableServicesForInterventionReportByFileId,
  updateQuotation,
  setQuotation,
  getCurrentQuotation,
  canCreateQuotationOnFileIdQuery,
  getPossibleRecipientTypesByFileIdQuery:
    CommonRepairerService.getPossibleRecipientTypesByFileIdQuery,
  getWorkTypesBySellerQuery,
  upsertWorkTypeCommand,
  getTechniciansBySellerIdQuery,
  deleteTechnicianCommand,
  upsertTechnicianCommand,
  getTechnicalInterventionsByDatesQuery,
  createPlanningCommentCommand,
  updateTechnicalInterventionCommand,
  getAvailableTimeSlotsQuery,
  getSelfOnboardingServicesQuery,
  getSelfOnboardingServiceDetailQuery,
  upsertSelfOnboardingServiceCommand,
  deleteSelfOnboardingServiceCommand,
  createTechnicalInterventionCommand,
  searchInterventionReportsCommand,
  getFilterFullIndexesQuery,
  setInterventionReportLineStatusCommand,
  setQuoteClientAnswerCommand:
    CommonRepairerService.setQuoteClientAnswerCommand,
  getPendingCustomerValidationByFileId:
    CommonRepairerService.getPendingCustomerValidationByFileId,
  getTechnicianByIdQuery,

  getQuoteMarginConfigurationQuery,
  getRepairersBySellerIdQuery,
  setQuoteMarginConfigurationCommand,
  deleteQuoteMarginConfigurationCommand,
  setRepairerQuoteMarginConfigurationCommand,
  deleteRepairerQuoteMarginConfigurationCommand,
  getGeographicZonesQuery,
  createGeographicZoneCommand,
  updateGeographicZoneCommand,
  deleteGeographicZoneCommand,
};
